export const localstorage = window.localStorage;
export default localstorage